export const createOption = (label: string, value: string) => ({
  label,
  value
});
